package com.hyperether.goodjob.models

import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.free
import com.hyperether.resources.stringResourcePlain
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Plan(
    @SerialName("id") var id: Long? = 0,
    @SerialName("_id") var _id: String? = null,
    @SerialName("name") var name: String? = null,
    @SerialName("price") var price: Double? = 0.0,
    @SerialName("perMonth") var perMonth: Double? = 0.0,
    @SerialName("description") var description: String? = null,
    @SerialName("storage") var storage: String? = null,
    @SerialName("planSupport") var planSupport: String? = null,
    @SerialName("limitUsers") var limitUsers: Long? = null,
    @SerialName("limitManagers") var limitManagers: Long? = null,
    @SerialName("isPopular") var isPopular: Boolean? = null,
    @SerialName("currency") var currency: String? = null,
    @SerialName("interval") var interval: String? = null,
    @SerialName("stripeProductId") var stripeProductId: String? = null,
    @SerialName("stripePriceId") var stripePriceId: String? = null,
    @SerialName("type") var type: String? = null,
    @SerialName("descriptions") val descriptions: Map<String, String>,
    @SerialName("names") val names: Map<String, String>,
    @SerialName("storages") val storages: Map<String, String>,
    @SerialName("planSupports") val planSupports: Map<String, String>
) {
    fun getName(locale: String): String? {
        return names[locale] ?: name
    }

    fun getDescription(locale: String): String? {
        return descriptions[locale] ?: description
    }

    fun getStorage(locale: String): String? {
        return storages[locale] ?: storage
    }

    fun getPlanSupport(locale: String): String? {
        return planSupports[locale] ?: planSupport
    }

    fun getPriceString(): String {
        val planPrice = when {
            price == 0.0 -> stringResourcePlain(Res.string.free)
            perMonth != null && perMonth != 0.0 -> "$${perMonth}"
            else -> "$${price}"
        }
        return planPrice
    }
}
